<template>
  <div class="product-filter-list-wrapper">
    <div class="columns">
      <div class="column is-12-mobile is-4-tablet is-3-desktop is-2-widescreen">
        <SearchFilters
          :filter-options="filterOptions"
          v-model:part-number-filter="partNumberFilter"
          v-model:pressure-ratings-filter="pressureRatingsFilter"
          v-model:connection-types-filter="connectionTypesFilter"
          v-model:sizes-filter="sizesFilter"
          v-model:application-types-filter="applicationTypesFilter"
          v-model:actuation-methods-filter="actuationMethodsFilter"
          v-model:industries-filter="industriesFilter"
        />
      </div>
      <div class="column is-12-mobile is-8-tablet is-9-desktop is-10-widescreen">
        <SearchResults
          :series="series"
          :part-number-filter="partNumberFilter"
          @load-more="loadMore"
          @add-to-compare="addToCompare"
          @remove-from-compare="removeFromCompare"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* global series, filterOptions, pageUrl */

import SearchFilters from './components/SeriesSearchFilters.vue'
import SearchResults from './components/SeriesSearchResults.vue'

export default {
  name: 'SeriesSearch',
  components: {
    SearchFilters,
    SearchResults
  },
  data () {
    return {
      allSeries: series,
      filterOptions: filterOptions,
      series: [],
      partNumberFilter: '',
      pressureRatingsFilter: [],
      connectionTypesFilter: [],
      sizesFilter: [],
      applicationTypesFilter: [],
      actuationMethodsFilter: [],
      industriesFilter: [],
      pageUrl: pageUrl,
      maxToShow: 20,
      pageSize: 20,
      currentlyShowing: 0,
      useLocalStorage: false,
      loadingComplete: false
    }
  },
  created: function () {
    if (typeof localStorage !== 'undefined') {
      this.useLocalStorage = true
    }

    var urlParams = [];
    (window.onpopstate = function () {
      var match
      var pl = /\+/g // Regex for replacing addition symbol with a space
      var search = /([^&=]+)=?([^&]*)/g
      var decode = function (s) { return decodeURIComponent(s.replace(pl, ' ')) }
      var query = window.location.search.substring(1)

      var filters = ['part_number', 'pressure_ratings', 'connection_types', 'sizes', 'application_types', 'actuation_methods', 'industries']

      while ((match = search.exec(query))) {
        if (filters.indexOf(decode(match[1])) >= 0 && decodeURIComponent(match[2]) !== '') {
          urlParams.push({ name: decode(match[1]), value: decodeURIComponent(match[2]) })
        }
      }
    })()

    // if we have urlParams load the data from those, otherwise load from local storage if we have it
    if (urlParams.length) {
      this.partNumberFilter = ''
      this.pressureRatingsFilter = []
      this.connectionTypesFilter = []
      this.sizesFilter = []
      this.applicationTypesFilter = []
      this.actuationMethodsFilter = []
      this.industriesFilter = []

      urlParams.forEach(function (urlParam) {
        const paramValue = urlParam.value
        switch (urlParam.name) {
          case 'part_number':
            this.partNumberFilter = paramValue
            break
          case 'pressure_ratings':
            this.pressureRatingsFilter.push(parseInt(paramValue))
            break
          case 'connection_types':
            this.connectionTypesFilter.push(parseInt(paramValue))
            break
          case 'sizes':
            this.sizesFilter.push(parseInt(paramValue))
            break
          case 'application_types':
            this.applicationTypesFilter.push(parseInt(paramValue))
            break
          case 'actuation_methods':
            this.actuationMethodsFilter.push(parseInt(paramValue))
            break
          case 'industries':
            this.industriesFilter.push(parseInt(paramValue))
            break
        }
      }, this)
    }
    /*
    else {
      // make sure we have local storage before we use it
      if (this.useLocalStorage) {
        this.partNumberFilter = (localStorage.getItem('partNumberFilter') === null) ? '' : localStorage.getItem('partNumberFilter')
        this.pressureRatingsFilter = (localStorage.getItem('pressureRatingsFilter') === null) ? [] : JSON.parse(localStorage.getItem('pressureRatingsFilter'))
        this.connectionTypesFilter = (localStorage.getItem('connectionTypesFilter') === null) ? [] : JSON.parse(localStorage.getItem('connectionTypesFilter'))
        this.sizesFilter = (localStorage.getItem('sizesFilter') === null) ? [] : JSON.parse(localStorage.getItem('sizesFilter'))
        this.applicationTypesFilter = (localStorage.getItem('applicationTypesFilter') === null) ? [] : JSON.parse(localStorage.getItem('applicationTypesFilter'))
        this.actuationMethodsFilter = (localStorage.getItem('actuationMethodsFilter') === null) ? [] : JSON.parse(localStorage.getItem('actuationMethodsFilter'))
        this.industriesFilter = (localStorage.getItem('industriesFilter') === null) ? [] : JSON.parse(localStorage.getItem('industriesFilter'))
      }
    }
    */

    this.buildUrl()
    this.filterSeries()
    this.loadingComplete = true
  },
  watch: {
    partNumberFilter: function () {
      // make sure we have local storage before we use it
      if (this.useLocalStorage) {
        localStorage.setItem('partNumberFilter', this.partNumberFilter)
      }
      if (this.loadingComplete) {
        this.maxToShow = 20
        this.buildUrl()
        this.filterSeries()
      }
    },
    pressureRatingsFilter: {
      handler: function () {
        // make sure we have local storage before we use it
        if (this.useLocalStorage) {
          localStorage.setItem('pressureRatingsFilter', JSON.stringify(this.pressureRatingsFilter))
        }
        if (this.loadingComplete) {
          this.maxToShow = 20
          this.buildUrl()
          this.filterSeries()
        }
      },
      deep: true
    },
    connectionTypesFilter: {
      handler: function () {
        // make sure we have local storage before we use it
        if (this.useLocalStorage) {
          localStorage.setItem('connectionTypesFilter', JSON.stringify(this.connectionTypesFilter))
        }
        if (this.loadingComplete) {
          this.maxToShow = 20
          this.buildUrl()
          this.filterSeries()
        }
      },
      deep: true
    },
    sizesFilter: {
      handler: function () {
        // make sure we have local storage before we use it
        if (this.useLocalStorage) {
          localStorage.setItem('sizesFilter', JSON.stringify(this.sizesFilter))
        }
        if (this.loadingComplete) {
          this.maxToShow = 20
          this.buildUrl()
          this.filterSeries()
        }
      },
      deep: true
    },
    applicationTypesFilter: {
      handler: function () {
        // make sure we have local storage before we use it
        if (this.useLocalStorage) {
          localStorage.setItem('applicationTypesFilter', JSON.stringify(this.applicationTypesFilter))
        }
        if (this.loadingComplete) {
          this.maxToShow = 20
          this.buildUrl()
          this.filterSeries()
        }
      },
      deep: true
    },
    actuationMethodsFilter: {
      handler: function () {
        // make sure we have local storage before we use it
        if (this.useLocalStorage) {
          localStorage.setItem('actuationMethodsFilter', JSON.stringify(this.actuationMethodsFilter))
        }
        if (this.loadingComplete) {
          this.maxToShow = 20
          this.buildUrl()
          this.filterSeries()
        }
      },
      deep: true
    },
    industriesFilter: {
      handler: function () {
        // make sure we have local storage before we use it
        if (this.useLocalStorage) {
          localStorage.setItem('industriesFilter', JSON.stringify(this.industriesFilter))
        }
        if (this.loadingComplete) {
          this.maxToShow = 20
          this.buildUrl()
          this.filterSeries()
        }
      },
      deep: true
    }
  },
  methods: {
    buildUrl: function () {
      var query = ''
      if (this.partNumberFilter !== '') {
        if (query.length) {
          query = query + '&'
        }
        query = query + 'part_number=' + this.partNumberFilter
      }
      if (this.pressureRatingsFilter.length) {
        if (query.length) {
          query = query + '&'
        }
        query = query + this.pressureRatingsFilter.map(function (value) {
          return 'pressure_ratings=' + value
        }).join('&')
      }
      if (this.connectionTypesFilter.length) {
        if (query.length) {
          query = query + '&'
        }
        query = query + this.connectionTypesFilter.map(function (value) {
          return 'connection_types=' + value
        }).join('&')
      }
      if (this.sizesFilter.length) {
        if (query.length) {
          query = query + '&'
        }
        query = query + this.sizesFilter.map(function (value) {
          return 'sizes=' + value
        }).join('&')
      }
      if (this.applicationTypesFilter.length) {
        if (query.length) {
          query = query + '&'
        }
        query = query + this.applicationTypesFilter.map(function (value) {
          return 'application_types=' + value
        }).join('&')
      }
      if (this.actuationMethodsFilter.length) {
        if (query.length) {
          query = query + '&'
        }
        query = query + this.actuationMethodsFilter.map(function (value) {
          return 'actuation_methods=' + value
        }).join('&')
      }
      if (this.industriesFilter.length) {
        if (query.length) {
          query = query + '&'
        }
        query = query + this.industriesFilter.map(function (value) {
          return 'industries=' + value
        }).join('&')
      }

      if (query.length) {
        history.replaceState(history.state, history.title, window.location.href.split('?')[0] + '?' + query)
      } else {
        history.replaceState(history.state, history.title, window.location.href.split('?')[0])
      }
    },
    filterSeries: function () {
      const filters = [{ propertyName: 'pressure_ratings', filter: 'pressureRatingsFilter' }, { propertyName: 'connection_types', filter: 'connectionTypesFilter' }, { propertyName: 'sizes', filter: 'sizesFilter' }, { propertyName: 'application_types', filter: 'applicationTypesFilter' }, { propertyName: 'actuation_methods', filter: 'actuationMethodsFilter' }, { propertyName: 'industries', filter: 'industriesFilter' }]
      var data = this

      data.currentlyShowing = 0
      data.series = []

      for (let i = 0; i < data.allSeries.length; i++) {
        var hide = false
        data.currentlyShowing++
        var checkSeries = data.allSeries[i]

        if (data.partNumberFilter !== '') {
          const matchedSkus = checkSeries.skus.filter((sku) => sku.toLowerCase().includes(data.partNumberFilter.toLowerCase()))
          if (matchedSkus.length === 0) {
            hide = true
            data.currentlyShowing--
          }
        }

        if (!hide) {
          filters.forEach(function (filterObj) {
            const property = filterObj.propertyName
            const filter = filterObj.filter
            if (!hide) {
              if (data[filter].length) {
                let matched = false
                for (let k = 0; k < data[filter].length; k++) {
                  const filterValue = parseInt(data[filter][k])
                  if (checkSeries[property].length) {
                    for (let l = 0; l < checkSeries[property].length; l++) {
                      const seriesValue = parseInt(checkSeries[property][l])
                      if (filterValue === seriesValue) {
                        matched = true
                      }
                    }
                  }
                }

                if (!matched) {
                  hide = true
                  data.currentlyShowing--
                }
              }
            }
          })
        }

        if (this.currentlyShowing > this.maxToShow) {
          hide = true
        }

        if (!hide) {
          this.series.push(checkSeries)
        }
      }
    },
    loadMore: function () {
      this.maxToShow += this.pageSize
      this.filterSeries()
    },
    async addToCompare (seriesId) {
      var postData = JSON.stringify({ series_id: seriesId })
      var data = this

      fetch(
        '/add-to-compare',
        {
          method: 'POST',
          body: postData,
          headers: { 'Content-type': 'application/json; charset=UTF-8' }
        }
      )
        .then(response => response.json())
        .then(function (json) {
          if (json.success) {
            for (let i = 0; i < data.allSeries.length; i++) {
              if (parseInt(data.allSeries[i].id) === parseInt(seriesId)) {
                data.allSeries[i].compared = true
              }
            }
            document.getElementById('compare-count').innerText = json.compareCount
            document.getElementById('mobile-compare-count').innerText = json.compareCount
            data.filterSeries()
          }
        })
        .catch(function (err) {
          // eslint-disable-next-line
          console.log(err)
        })
    },
    async removeFromCompare (seriesId) {
      var postData = JSON.stringify({ series_id: seriesId })
      var data = this

      fetch(
        '/remove-from-compare',
        {
          method: 'POST',
          body: postData,
          headers: { 'Content-type': 'application/json; charset=UTF-8' }
        }
      )
        .then(response => response.json())
        .then(function (json) {
          if (json.success) {
            for (let i = 0; i < data.allSeries.length; i++) {
              if (parseInt(data.allSeries[i].id) === parseInt(seriesId)) {
                data.allSeries[i].compared = false
              }
            }
            document.getElementById('compare-count').innerText = json.compareCount
            document.getElementById('mobile-compare-count').innerText = json.compareCount
            data.filterSeries()
          }
        })
        .catch(function (err) {
          // eslint-disable-next-line
          console.log(err)
        })
    }
  }
}
</script>
